export // eslint-disable-next-line @typescript-eslint/no-explicit-any
function createMessage(format: (...strArgs: any[]) => string, ...args: any[]) {
  return format(...args);
}

export const MOXO_SCRIPT_LOAD_SUCCESS = () =>
  `Moxo script loaded successfully.`;

export const MOXO_TOKEN_ERROR = () => `Moxo token generation failed!.`;

export const MOXO_TOKEN_SUCCESS = () =>
  `Moxo token generation successful! Please start the chat.`;

export const MOXO_SCRIPT_LOAD_ERROR = () => `Moxo script load failed!.`;
